module.exports = __webpack_public_path__ + "static/media/install6.cf347777.png";